import React, { useEffect, useMemo, lazy, Suspense, useRef } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { useOperatorProfileContext } from "provider/OperatorProfileProvider";
import ShaerdSafariTourTabSekelton from "components/common/Skeleton/safariTabSekelton/ShaerdSafariTourTabSekelton";

const ShaerdSafari = lazy(() => import("./sharesafari/ShaerdSafari"));
const OperaterPackage = lazy(() => import("./package/OperaterPackage"));
const Parks = lazy(() => import("./parks/Parks"));
const OperatorReview = lazy(() => import("./review/OperatorReview"));
const Contact = lazy(() => import("./contact/Contact"));

const SafariTourOperatorsDetails = React.memo(() => {
  const { loadingOpProfile, opSharedSafariLoading, activeTab, opPackageLoading, operatorProfileDispatch } = useOperatorProfileContext();
  // 
  const handleTabClick = (tabname) => {
    operatorProfileDispatch({ type: "SET_PROFILE_ACTIVE_TAB", payload: tabname });
  }

  return (
    <>
      <Row
        className="pt-0 itenary_tabs justify-content-center position-relative bg-white"
        id="safari_tour_operator_container"
      >
        <Tab.Container defaultActiveKey="shaerd-safari">
          <Col xxl={11}>

            <Row>
              <Col
                lg={{ span: 8, offset: 4 }}
                xl={{ span: 9, offset: 3 }}
                xxl={{ span: 10, offset: 2 }}
                className="mt-2 position-relative safartabs"
              >
                 <div className="overflow-auto w-100 hide-scrollbar">
                <Nav className="nav-tabs slider_addmobile3 owl-theme d-flex gap-2 flex-nowrap">
                  <Nav.Item>
                    <Nav.Link eventKey="shaerd-safari" onClick={() => handleTabClick("shaerdsafari")}>Shaerd Safari</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Packages" onClick={() => handleTabClick("packages")}>Packages</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Parks" onClick={() => handleTabClick("parks")}>Parks</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="reviews" onClick={() => handleTabClick("reviews")}>Review</Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                    <Nav.Link eventKey="contact" onClick={() => handleTabClick("contact")}>Contact</Nav.Link>
                  </Nav.Item> */}
                </Nav>
                </div>
              </Col>
            </Row>
          </Col>
          <Tab.Content className="mt-0" style={{ background: "#f5f5f5" }}>
            <Tab.Pane eventKey="shaerd-safari" className="mt-3">
              <Suspense fallback={<ShaerdSafariTourTabSekelton />}>
                {opSharedSafariLoading ? <ShaerdSafariTourTabSekelton />
                  :
                  <ShaerdSafari />
                }
              </Suspense>
            </Tab.Pane>
            <Tab.Pane eventKey="Packages" className="mt-3">
              <Suspense fallback={<ShaerdSafariTourTabSekelton />}>
                {loadingOpProfile ? <ShaerdSafariTourTabSekelton />
                  : <OperaterPackage />
                }
              </Suspense>

            </Tab.Pane>
            <Tab.Pane eventKey="Parks" className="mt-3">
              <Suspense fallback={<ShaerdSafariTourTabSekelton />}>
                {loadingOpProfile ? <ShaerdSafariTourTabSekelton />
                  : <Parks />
                }
              </Suspense>

            </Tab.Pane>
            <Tab.Pane eventKey="reviews" className="mt-3">
              <OperatorReview />
            </Tab.Pane>
            <Tab.Pane eventKey="contact" className="mt-3">
              <Contact />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Row>
    </>
  );
})

export default SafariTourOperatorsDetails;
